import styled from "@emotion/styled";
import * as Dialog from "@radix-ui/react-dialog";

export const CopyDeleteOverlay = styled(Dialog.Overlay)`
    position: fixed;
    inset: 0;
    @media (min-width: 768px) { left: var(--sidebar-width, 0px); }
    background: transparent;
`;

export const CopyDeleteContent = styled(Dialog.Content)<{
    anchorRect: DOMRect | null;
}>`
    position: fixed;

    ${({ anchorRect }) =>
    anchorRect
        ? `
        top: ${anchorRect.bottom + 8}px;
        left: ${anchorRect.right}px;
        transform: translateX(-100%);
      `
        : `
        top: 72px;
        right: 24px;
      `}

    width: 224px;
    height: 102px;
    padding: 12px;
    border-radius: 12px;
    border-width: 1px;
    border-style: solid;
    border-color: #2b2d33;
    background: #23252a;
    display: flex;
    flex-direction: column;
    gap: 6px;
    box-sizing: border-box;
    z-index: 2001;
`;

export const CopyDeleteItem = styled.button`
    width: 200px;
    height: 36px;
    padding: 0 12px;
    border-radius: 8px;
    border: none;
    display: flex;
    align-items: center;
    cursor: pointer;
    background: transparent;

    font-family: Inter, system-ui, sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0;
    vertical-align: middle;
    color: #e9ecf5;

    &:hover {
        background: #2b2d33;
    }

    &.delete {
        color: #d65f46;
    }
`;
